// export const LOAD_UPCOMING_RESERVATIONS = 'LOAD_UPCOMING_RESERVATIONS';
export const LOAD_DASHBOARD_HOME = "LOAD_DASHBOARD_HOME";

export const UNAUTHORIZED = "UNAUTHORIZED";

export const LOAD_REVIEW_DETAILS = "LOAD_REVIEW_DETAILS";

export const LOAD_RESERVATIONS = "LOAD_RESERVATIONS";

export const LOAD_REVIEWS = "LOAD_REVIEWS";
export const LOAD_EDIT_REVIEW_DETAILS = "LOAD_EDIT_REVIEW_DETAILS";

export const LOAD_REVIEW_DETAILS_SCORES = "LOAD_REVIEW_DETAILS_SCORES";

export const LOAD_REVIEW_PERFORMANCE = "LOAD_REVIEW_PERFORMANCE";
export const LOAD_REVIEW_CATEGORIES = "LOAD_REVIEW_CATEGORIES";
export const LOAD_REVIEW_IMAGES = "LOAD_REVIEW_IMAGES";

export const LOAD_USER_PAYMENTS = "LOAD_USER_PAYMENTS";

export const GET_WISHLIST = "GET_WISHLIST";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";

export const LOAD_SINGLE_RESERVATION = "LOAD_SINGLE_RESERVATION";

export const LOAD_CHATS = "LOAD_CHATS";
export const LOAD_NEW_MESSAGE = "LOAD_NEW_MESSAGE";
export const UN_LOAD_NEW_MESSAGE = "UN_LOAD_NEW_MESSAGE";
export const UPDATE_MESSAGE_STATUS = "UPDATE_MESSAGE_STATUS";

export const UPDATE_NOTIFICATION_STATUS = "UPDATE_NOTIFICATION_STATUS";
export const UPDATE_CHAT_LIST_ITEM = "UPDATE_CHAT_LIST_ITEM";
